
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import StatePricingService from '@/apps/shared/services/statePricing-service';
    import ContractFinish from "@/apps/shared/components/ContractFinish.vue";
    import { TitleAndPromotionsDetails } from '@/apps/shared/models/titleAndPromotionsDetails';
    import webSaleHelper from '@/apps/shared/utils/webSaleHelper';
    import ParamCotizService from '@/apps/shared/services/ParamCotizOfSession-service';
    import MailService from '@/apps/shared/services/email-service';
    import DateService from '@/apps/shared/utils/formatDate';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';

    // Código de la plantilla de Asistencia al Viajero en el sistema de mailing del ESB
    // (AP = "1", Movilidad = "26", EE = "27", Combinado = "28").
    const TRAVEL_ASSISTANCE_REPORT_CODE = '104';

    interface payload {
        productId: number;
        pricingId: number;
        leadId: string;
        contratante: {
            firstName: string;
            lastName: string;
            documentNumber: string;
            documentType: number;
            areaCode: string;
            telephone: string;
            email: string;
            ivaCondition: number;
            localityName?: string;
        };
        plan: {
            name: string;
            priceFormatted: string;
            premioMensual?: string | number;
        };
        travelData: any;
        passengers: any[];
        referente: string;
    }

    export default Vue.extend({
        components: {
            ContractFinish
        },
        name: 'TravelAssistanceFinalPayment',
        data() {
            return {
                titleAndPromotionDetails: {
                    icon: {
                        src: '/Icons/check.png',
                    },
                } as TitleAndPromotionsDetails,
                payload: null as payload | null,
                referente: null,
            }
        },
        methods: {
            async pageCustomization() {
                const defaultTitle = 'Asistencia al Viajero';
                const actualPath = '/asistencia-viajero';
                try {
                    await webSaleHelper.pageCustomization(this.$route, this.Bus, this.$store, defaultTitle, actualPath, null, null);
                }
                catch (error) {
                    const statusCode = error.response?.status;
                    this.Bus.$emit(
                        'show-service-fail',
                        statusCode,
                        [() => this.pageCustomization()]);
                }
            },

            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultTravelAssistanceGTMInfo';
                this.Bus.$emit('updateByProductGoogleAnalytics', productGtmName);
            },

            getFilePath() {
                this.$router.push({ name: 'travelAssistance-tab-One' });
            },

            pushServerError() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                window.globalThis.dataLayer.push({
                    'pas': null,
                    'email': this.payload && this.payload.contratante ? this.payload.contratante.email : null,
                    'referente': this.payload && this.payload.referente ? this.payload.referente : this.referente,
                    'product': 'asistencia-viaje',
                    'event': 'errorServidor',
                    'paso': 'cotizador-asistencia-viaje-venta-complet'
                });
            },

            fetchSessionPayload(guid: string): Promise<void> {
                // GUID persistido, necesario para que CUPEController/Finish validen por pricingId.
                return ParamCotizService.getParamCotiz(guid)
                    .then(resp => {
                        if (!resp.hasData || !resp.data) {
                            console.warn(resp.message);
                            throw new Error(resp.message);
                        }
                        this.payload = JSON.parse(resp.data) as payload;
                    });
            },

            formatDateFromSession(dateValue) {
                if (!dateValue) return '';
                const d = new Date(dateValue);
                if (isNaN(d.getTime())) return '';
                return DateService.formatDate(d);
            },

            getMailValues() {
                const payload = this.payload!;
                const c = payload.contratante;
                const travelData = payload.travelData || {};

                const nombreRaw = (c.firstName || '').toLowerCase().split(' ')[0];
                const firstName = nombreRaw.charAt(0).toUpperCase() + nombreRaw.slice(1);

                // priceFormatted ya trae el prefijo "U$D" y la etiqueta del template es "Costo U$D:".
                const costoUsd = (payload.plan?.priceFormatted || '').replace(/^U\$D\s*/, '');

                // Tokens del template registrado bajo el ReportCode 104 (body-mail-asistencia-viajero-v2):
                // @contratante, @cantidadPersonas, @tipoViaje, @destino, @costoUSD, @fechaSalida, @fechaRegreso.
                // Las imágenes (@HeaderImage, @ProductImage, @ContactImage, logos) las inyecta MailController.
                const parameters = [
                    { name: '@ReportCode', value: TRAVEL_ASSISTANCE_REPORT_CODE },
                    { name: '@contratante', value: firstName },
                    { name: '@cantidadPersonas', value: String(travelData.passengersCount || (payload.passengers ? payload.passengers.length : '')) },
                    { name: '@tipoViaje', value: travelData.tripType ? travelData.tripType.description : '' },
                    { name: '@destino', value: travelData.destination ? travelData.destination.description : '' },
                    { name: '@costoUSD', value: costoUsd },
                    { name: '@fechaSalida', value: this.formatDateFromSession(travelData.departureDate) },
                    { name: '@fechaRegreso', value: this.formatDateFromSession(travelData.returnDate) },
                ];

                return JSON.stringify({
                    parameters: parameters,
                    to: c.email,
                    from: 'cotizador@sancorseguros.com',
                    productId: payload.productId
                });
            },

            async addFinishQuotation() {
                sessionStorage.setItem("ExitOrContinueModal", "true");

                const payload = this.payload;
                if (!payload) return;

                const externalIdentifier = payload.pricingId.toString();
                const clientData = payload.contratante;
                const ramo = "Asistencia al Viajero";

                const premioMensual = parseInt(String(payload.plan?.premioMensual ?? 0).replace(/\./g, ''), 10);

                StatePricingService.getStatePricing(1, null, externalIdentifier, 30);
                StatePricingService.getStatePricing(1, null, externalIdentifier, 31);

                NF.UI.Page.block();
                await CUPEService.Finish(
                    parseInt(externalIdentifier),
                    1018,
                    clientData.lastName,
                    clientData.documentNumber,
                    clientData.localityName || null,   // localidad del contratante (BUP o cargada en el front), igual que AP
                    clientData.email,
                    clientData.firstName,
                    externalIdentifier,
                    premioMensual,
                    payload.plan?.name,
                    ramo,
                    clientData.areaCode,
                    clientData.telephone
                ).catch(error => {
                    // Finish rechazado (p. ej. pricingId de sesión distinto): se registra y se propaga como hasta ahora
                    this.pushServerError();
                    throw error;
                }).then(async (finishResult) => {
                    if (finishResult) {
                        window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                        window.globalThis.dataLayer.push({
                            'pas': null,
                            'email': clientData.email,
                            'referente': payload.referente,
                            'product': 'asistencia-viaje',
                            'event': 'cotizador-asistencia-viaje-venta-complet',
                            'value': premioMensual
                        });
                        window.globalThis._qsie = window.globalThis._qsie || [];
                        window.globalThis._qsie.push('cotizador-asistencia-viaje-venta-complet');
                        CRMCotizadorWebService.CreateOrEditLead(payload.leadId, null, location.href, null, null, 1018, true, "7", null, null, null);

                        await MailService.sendMail(this.getMailValues()).then(mailResp => {
                            NF.Notification.show({
                                type: mailResp.result ? NF.Notification.Type.SUCCESS : NF.Notification.Type.ERROR,
                                title: mailResp.result ? 'Mail Enviado' : 'Error',
                                content: mailResp.result ? 'Mail enviado exitosamente.' : 'Se produjo un error inesperado.',
                                position: NF.Notification.Positions.TOP_RIGHT,
                                clickClose: true,
                                autoHideDelay: 10000,
                            });
                        });
                    } else {
                        // Mercado Pago no aprobo la operacioón
                        this.pushServerError();
                    }
                }).finally(() => NF.UI.Page.unblock());
            },
        },
        async mounted() {
            try {
                NF.UI.Page.block();

                var referente = sessionStorage.getItem("Referente");
                referente == 'null' || referente == null ? this.referente = null : this.referente = referente;

                await this.pageCustomization();
                await this.updateByProductGoogleAnalytics();

                const guid = sessionStorage.getItem('ParamId');
                if (guid) {
                    try {
                        await this.fetchSessionPayload(guid);
                    } catch (error) {
                        this.pushServerError();
                        throw error;
                    }
                    await this.addFinishQuotation();
                }
            } finally {
                NF.UI.Page.unblock();
            }
        },
    });
